<ng-container *transloco="let convert;">
  @if (isVisible) {
    <div class="offer-history">
      <ng-container>
        <header>
          <h2 class="text-brand fw-normal" tabindex="-1" #heading>
            {{convert('sellModule.offers.history.textHistory')}}
          </h2>
          @if (rootOffer.status === 'ACCEPTED') {
            <p class="accepted-message"
              [innerHTML]="convert('sellModule.offers.history.textAccept', {dealershipName : mainOffer.dealershipName})">
            </p>
          }
        </header>
        <div class="offer-details">
          <div class="offer-details__item">
            <div class="offer-details__item-label">{{convert('sellModule.offers.history.textVIN')}}</div>
            <div [id]="'offer_details_history_vin_' + index" class="offer-details__item-value">
              {{ inventoryItem.itemDetail.vin }}
            </div>
          </div>
          <div class="offer-details__item">
            <div class="offer-details__item-label">{{convert('sellModule.offers.history.textOfferDate')}}</div>
            <div [id]="'offer_details_history_offer_date_' + index" class="offer-details__item-value">
              {{ formatDate(rootOffer.offerDate) }}
            </div>
          </div>
          <div class="offer-details__item">
            <div class="offer-details__item-label">{{convert('sellModule.offers.history.textOffer')}}</div>
            <div [id]="'offer_details_history_amount_' + index" class="offer-details__item-value">
              {{ formatCurrency(rootOffer.amount) }}
            </div>
          </div>
          <div class="offer-details__item">
            <div class="offer-details__item-label">{{convert('sellModule.offers.history.textStatus')}}</div>
            <div [id]="'offer_details_history_status_' + index" class="offer-details__item-value">
              {{ rootOffer.status | offerStatus }}
            </div>
          </div>
        </div>
        <div class="offer-chain" [ngClass]="historyCount > 3 ? 'has-scroll' : ''" tabindex="0">
          @for (date of previousOffers.dates; track date; let i = $index) {
            <div class="offer-chain__date">
              <span [id]="'offer_details_history_transaction_date_' + i" class="offer-chain__date-text">
              {{ formatDate(date) }}</span>
            </div>
            @for (offer of previousOffers.offersByDate[date]; track offer; let even = $even; let prevIndex = $index) {
              <div
                class="offer-chain--details" [ngClass]="even && historyCount > 1 ? 'row-even' : 'row-odd'">
                <div class="row space-between">
                  <p [id]="'offer_details_history_role_' + index + i + prevIndex" class="bold">
                    {{ convert(offer.role) }}
                    <ng-container [ngTemplateOutlet]="offerUserName"
                    [ngTemplateOutletContext]="{offer:offer}"></ng-container>
                  </p>
                  <p>{{ offerDate(offer.offerDate) }}</p>
                </div>
                <p [id]="'offer_details_history_status_' + index + i + prevIndex">
                  <span class="bold">{{convert('sellModule.offers.history.textStatus')}}</span> {{ convert(offer.status |
                  offerStatus) }}
                </p>
                <p [id]="'offer_details_history_amount_' + index + i + prevIndex">
                  <span class="bold">{{convert('sellModule.offers.history.textOfferAmount')}}</span>
                  {{ formatCurrency(offer.amount)}}
                </p>
                <p [id]="'offer_details_history_comments_' + index + i + prevIndex" class="pt-3 fst-italic">
                  <span class="bold fw-bold">{{convert('sellModule.offers.common.labelComment')}}</span> {{
                  offer.comment }}
                </p>
              </div>
            }
          }
        </div>
        <div class="offer-history__footer d-none d-lg-block" [ngClass]="historyCount > 3 ? 'has-scroll' : ''"></div>
        <div class="offer-history__footer-mobile d-flex flex-column d-lg-none">
          <button class="btn btn-primary" type="submit" data-track-elem="button" data-track-name="Close History"
            (click)="closeClicked()">
            {{convert('common.btnClose')}}
          </button>
        </div>
      </ng-container>
    </div>
  }

  <ng-template #offerUserName let-offer="offer">
    @if ( showBuyerUserNameToSeller || offer.role === 'SELLER' && getOfferUserName(offer).length > 0) {
      -
      @if (isMobile && getOfferUserName(offer).length >= 14) {
        <app-tooltip [tooltip]="{ body: getOfferUserName(offer) }" triggers="click hover :keydown.escape :keydown.tab">
          <span [attr.aria-label]="getOfferUserName(offer)">{{ getOfferUserName(offer).substr(0, 14).trim() + '...'
          }}</span>
        </app-tooltip>
      }
      @if (!isMobile && getOfferUserName(offer).length >= 48) {
        <app-tooltip [tooltip]="{ body: getOfferUserName(offer) }" triggers="click hover :keydown.escape :keydown.tab">
          <span [attr.aria-label]="getOfferUserName(offer)">{{ getOfferUserName(offer).substr(0, 48) + '...' }}</span>
        </app-tooltip>
      }
      @if ((isMobile && getOfferUserName(offer).length < 14) || (!isMobile && getOfferUserName(offer).length < 48)) {
        {{ getOfferUserName(offer)}}
      }
    }
  </ng-template>
</ng-container>
